import {Space} from "antd";
import {ExclamationCircleTwoTone} from "@ant-design/icons";

function ValidationError({text, styles, valid = false}) {
  const style = {marginTop: 4, marginBottom: 4, padding: "1px 4px", background: "rgba(255,255,255,0.23)",
    borderRadius: 4, width: "fit-content", color: valid ? "#006a0d" : "#ec0000", fontSize: 12, ...styles};
  return (
    <div style={style}>
      <Space size={4}>
        <ExclamationCircleTwoTone style={{marginTop: 4}} twoToneColor={valid ? "#006a0d" : "#FF0000"} />
        {text}
      </Space>
    </div>
  );
}

export default ValidationError;
